import calculateTotals from './calculateTotals'
import { roundTo } from './formatNumbers'

export const getTotalLiters = (bestellung) => {
	let total = bestellung.liefermenge
	Object.values(bestellung.lieferstellen).map(lieferstelle => { 
		return total += lieferstelle.liefermenge
	})
	return total
}

export const getMarge = (region, settings, bestellung, setBestellung) => { 
	let marge = []
	const total = getTotalLiters(bestellung)

	
	if (Object.values(settings).length > 0) {

		// console.log(Object.values(settings[region.region]))

		marge = settings[region.region].margen.filter((item) => { 
		 	return total >= parseInt(item.liter)
		})

	}
	
	// console.log('AUFSCHLAG ', marge, marge[marge.length - 1].marge)
	if (marge.length > 0) {


		setBestellung(prev => ({
			...prev,			
			totals: {
				...prev.totals,
				totalAmount: total,
				marge: parseFloat(marge[marge.length - 1].marge),
				per100Netto: prev.totals.productName !== '' ?
					roundTo( parseFloat(prev.basePrice) +
					parseFloat(prev.settings.vorfracht) +
					parseFloat(prev.aufpreis) +
					parseFloat(prev.totals.productAufpreis ? prev.totals.productAufpreis : 0) +
					parseFloat(marge[marge.length - 1].marge) -
					parseFloat(prev.totals.aktion ? prev.totals.aktion : 0), 2) : 0,
				allTotalNetto: calculateTotals(prev.totals, bestellung.anzahlLieferstellen)
			}
		}))
	}
}

export const calculateNetto100 = (props, product) => {	
	const netto100 = props.bestellung.totals.marge +
	parseFloat(props.bestellung.basePrice) +
	parseFloat(props.bestellung.aufpreis) +
	parseFloat(props.bestellung.settings.vorfracht) +
	parseFloat(product.acf.aufpreis ? product.acf.aufpreis : 0) -
		parseFloat(product.acf.rabatt_aktion ? product.acf.rabatt_aktion : 0)
	return netto100
}